@for (row of tableRows; track dataTrackBy(index, row); let index = $index) {
    <ng-container
        [ngTemplateOutlet]="recursiveRowTemplate"
        [ngTemplateOutletContext]="{ row, index }"></ng-container>
}

<ng-template #recursiveRowTemplate let-row="row" let-index="index">
    @if ((row.parent && row.parent.expanded) || !row.parent) {
        <tr
            [ngClass]="row.classes"
            cdkDrag
            [class.alternate-child-row]="row.parent && row.level % 2 === 1"
            [ngStyle]="{ backgroundColor: row.backgroundColor }">
            @if (isDraggable) {
                <td
                    class="drag-handle"
                    cdkDragHandle
                    [class.drag-disabled]="isDraggableDisabled">
                    <pf-icon iconType="drag"></pf-icon>
                </td>
            }
            @if (expandable) {
                <td
                    [(nzExpand)]="row.expanded"
                    [nzIndentSize]="row.indentSize"
                    [nzShowExpand]="shouldDisplayExpandIcon(row)"
                    (nzExpandChange)="expandHandler($event, row)"></td>
            }
            @if (showSelection) {
                <td
                    [(nzChecked)]="row.checked"
                    (nzCheckedChange)="checkedHandler($event, index)"></td>
            }
            @for (column of columns;
                track headerTrackBy($index, column);
                let first = $first) {
                <td
                    [attr.data-pf-table-column]="column.headerName"
                    [nzIndentSize]="first ? row.indentSize : 0">
                    <pf-table-cell
                        [row]="row"
                        [column]="column"
                        [expandToContent]="expandToContent"></pf-table-cell>
                </td>
            }
            @if (actions.length > 0) {
                <td nzRight class="table-actions-cell">
                    <pf-table-actions
                        [actions]="actions"
                        [row]="row"
                        [index]="index"></pf-table-actions>
                </td>
            }
        </tr>
    }
    @if (row.children && row.children.length && row.expanded) {
        @for (child of row.children; track childTrackBy(child)) {
            <ng-container
                [ngTemplateOutlet]="recursiveRowTemplate"
                [ngTemplateOutletContext]="{
                    row: child,
                    index
                }"></ng-container>
        }
    }
    @if (row.expandable && expandRowRef) {
        <tr [nzExpand]="row.expanded">
            <ng-container
                *ngTemplateOutlet="
                    expandRowRef;
                    context: {
                        columns,
                        row,
                        actions,
                        index,
                        expanded: row.expanded
                    }
                "></ng-container>
        </tr>
    }
</ng-template>
